<template>
  <section class="main-content">
    <MainBanner banner="Wir.Philosophie" />
    <script type="application/ld+json">
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Startseite - ito consult GmbH",
        "item": "https://ito-consult.de"
      },{
        "@type": "ListItem",
        "position": 2,
        "name": "Über uns",
        "item": "https://ito-consult.de/wir"
      },{
        "@type": "ListItem",
        "position": 3,
        "name": "Philosophie",
        "item": "https://ito-consult.de/wir/philosophie"
      }]
    }
  </script>
    <section class="block-content py-5 mb-5 bg-grey">
        <div class="container my-md-5 py-md-5">
            <div class="content-midwide text-center" data-aos="fade-up" data-aos-duration="1000" data-aos-offset="100">
              <article v-html="philosophie_content"></article>
            </div>
        </div>
    </section>
    <section class="block-content mb-5">
        <div class="container">
            <div id="philosoophy">
                <article class="d-content" v-html="main_content"></article>
            </div>
        </div>
    </section>
  </section>
</template>

<script>

import store from '@/store'
const MainBanner = () => import('@/components/Content/MainBanner.vue')

export default {
  name: 'Philosophy',
  metaInfo () {
    return {
      title: this.$parent.getMetaTitle('Wir.Philosophie'),
      meta: [
        { name: 'description', content: this.$parent.getDescription('Wir.Philosophie') },
        { property: 'og:title', content: this.$parent.getOGTitle('Wir.Philosophie') },
        { property: 'og:description', content: this.$parent.getOGDescription('Wir.Philosophie') }
      ]
    }
  },
  data: function () {
    return {
      content: null
    }
  },

  computed: {
    philosophie_content () {
      if (typeof this.$store.getters.content.data !== 'undefined') {
        const txt = this.$store.getters.content.data.filter(item => {
          return item.title.indexOf('Philosophie-Einleitung') > -1
        })
        return txt.length ? txt[0].content : ''
      } else {
        return ''
      }
    },
    main_content () {
      if (typeof this.$store.getters.content.data !== 'undefined') {
        const txt = this.$store.getters.content.data.filter(item => {
          return item.title.indexOf('Philosophie') > -1
        })
        return txt.length ? txt[0].content : ''
      } else {
        return ''
      }
    }
  },
  components: {
    MainBanner
  },
  mounted () {
    store.commit('loadingStatus', false)
  }

}
</script>
